import React from 'react';
import { Button, WysiwygField as DefaultWysiwygField, TableRender } from '@uncinc/uncinc-react-kitchen-sink';

import { isExternalLink } from '@uncinc/uncinc-react-kitchen-sink/dist/helpers/link';
import { convertNodeToElement } from 'react-html-parser';

export const customElementHandler = (node) => {
  switch (node.name) {
    case 'table': {
      return (
        <TableRender element={convertNodeToElement(node)} {...node.attribs} />
      );
    }
    case 'a': {
      const label = node.children[0].data;
      if (node.attribs.class && node.attribs.class.indexOf('button--primary') !== -1) {
        return (
          <Button primary withIcon buttonIcon href={node.attribs.href} target={node.attribs.target || ''} rel={node.attribs.target ? 'noopener' : ''} key={`${node.name}:${label}`}>
            {label}
          </Button>
        );
      } else if (isExternalLink(node.attribs.href)) {
        return (
          <a href={node.attribs.href} className={node.attribs.class} target="_blank" rel="noreferrer noopener">
            {label}
          </a>
        );
      }
      break;
    }
    default: {
      return null;
    }
  }
};

const WysiwygField = (props) => {
  return (
    <DefaultWysiwygField
      customElementHandler={customElementHandler}
      {...props}
    />
  );
};

export default WysiwygField;
